module.exports = __webpack_public_path__ + "img/iphone-x-mockup (20).8790b9dc.png";